import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from '../../definition/menu-item.model';
import { SiderMenuService } from 'mm-web-core/menu/services/sider-menu.service';
import { takeUntil, tap, filter } from 'rxjs/operators';
import { ChangePasswordComponent } from 'shared/components/change-password/change-password.component';
import { UserInfoComponent } from 'shared/components/user-info/user-info.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ThemeService } from 'shared/services';
import { ThemeSubscribeService } from 'mm-web-core/services/theme.subscribe.service';
import { ContentSizeSubscribeService } from 'app/service/contentsize.subscribe.service';
import { MenuServiceService } from '../sider-menu/menu-service.service';
import { TranslateService } from '@ngx-translate/core';
import { SubjectService } from 'app/service/subject.service';

@Component({
  selector: 'mm-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class MmAppComponent implements OnInit, OnDestroy {
  protected modalService: NzModalService;
  items$ = new BehaviorSubject<MenuItem[]>([]);
  onDestroy$ = new Subject();
  sliderShow: boolean = true;
  sliderLeft: boolean = true;
  currentTheme: string;
  userName: string;
  breadcrumbs: string[] = null;
  breadcrumbConfig: any = {};
  constructor(
    private httpClient: HttpClient, 
    private router: Router, 
    private siderMenuService: SiderMenuService, 
    private translation: TranslateService,
    private subjectService: SubjectService,
    private menuSubscribeService: MenuServiceService, 
    protected injector: Injector, 
    protected themeService: ThemeService, 
    private themeSubscribeService: ThemeSubscribeService, 
    private contentSizeSubscribeService: ContentSizeSubscribeService) {
    this.modalService = injector.get(NzModalService);
    (this.router.events.pipe(filter(event => event instanceof NavigationEnd)) as Observable<NavigationEnd>).subscribe(router => {
      this.setCurrentBreadcrumbs();
      this.setUserPermissions();
    })
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  changeLanguage(lang: string) {
    if (lang === this.translation.currentLang) {
      return
    }
    this.translation.use(lang)
  }

  isCollapsed = false;
  async ngOnInit() {
    this.userName = localStorage.getItem('userName')
    var theme = this.themeService.getTheme();
    this.currentTheme = theme || 'light';

    this.siderMenuService.onRefresh$.pipe(
      takeUntil(this.onDestroy$),
      tap(async () => await this.loadMenus())
    ).subscribe();
    this.loadMenus();
    this.menuSubscribeService.getObservable().subscribe(res => {
      this.breadcrumbConfig = {};
      this.setMenuConfig(res);
      this.setCurrentBreadcrumbs()
    })
  }

  setCurrentBreadcrumbs() {
    var routerUrl = this.router.routerState.snapshot.url.substr(1).toLowerCase();
    // 外部链接进行解码，然后再匹配
    if(routerUrl.indexOf('external-link') > -1){
      routerUrl = decodeURIComponent(routerUrl.split('url=')[1]) 
    }
    this.breadcrumbs = this.breadcrumbConfig[routerUrl];
    this.loadTabs()
  }

  async setUserPermissions() {
    if (!localStorage.getItem('permissions')) return;
    const currentPermissions = await this.httpClient.get<Array<string>>("api/_identity/userPermissions").toPromise();
    const localPermissions = JSON.parse(localStorage.getItem('permissions')) as Array<string>;
    const intersectPermissions = localPermissions?.filter(v => currentPermissions.includes(v));
    const newPerssions = currentPermissions?.filter(v => !intersectPermissions.includes(v));
    const removePerssions = localPermissions?.filter(v => !intersectPermissions.includes(v));
    localStorage.setItem("permissions", JSON.stringify(currentPermissions));
    if (newPerssions?.length > 0 || removePerssions?.length > 0) {
      this.subjectService.setUserPermissionsSubject({ new: newPerssions, remove: removePerssions });
    }
  }

  setMenuConfig(menus) {
    menus?.map(item => {
      if (item.url !== null && (item.type === 'ExternalLink' || item.type == 'Link')) {
        this.breadcrumbConfig[(item.url).toLowerCase()] = [item.name];
      }
      if (item.type == 'Folder') {
        this.setMenuConfig(item.items)
      }
    })

    for (var url in this.breadcrumbConfig) {
      var m = menus?.filter(v => v.url === url || v.items?.filter(s => s.url == url).length > 0)[0];
      if (m && !this.breadcrumbConfig[url].includes(m.name)) {
        this.breadcrumbConfig[url] = [m.name].concat(this.breadcrumbConfig[url]);
      }
    }
  }
  async loadMenus() {
    let items = await this.httpClient.get<MenuItem[]>("api/_menu/tree").toPromise();
    this.items$.next(items);
  }


  hasItems(item: MenuItem) {
    return item.items && item.items.length > 0;
  }
  navigate(paths: string[]) {
    this.router.navigate(paths);
  }

  combinePaths(paths: string[], path: string) {
    return [...paths, path];
  }

  /**
   * 个人信息
   */
  openUserInfo() {
    this.modalService.create({
      nzTitle: this.translation.instant('User.UserInfo'),
      nzContent: UserInfoComponent,
      nzMaskClosable: false,
    });
  }

  /**
   * 修改密码
   */
  changPwd() {
    this.modalService.create({
      nzTitle: this.translation.instant('Layout.ModifyPassword'),
      nzContent: ChangePasswordComponent,
      nzMaskClosable: false,
    });
  }

  /**
   * 退出登录
   */
  siginout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  changeSplidPosition(isLeft) {
    this.sliderLeft = isLeft;
  }
  changeSplidVisable() {
    this.sliderShow = !this.sliderShow;
    this.contentSizeSubscribeService.sizeChange();
  }
  changeFold() {
    this.isCollapsed = !this.isCollapsed;
    this.contentSizeSubscribeService.sizeChange();
  }

  /**
   * 切换主题
   */
  changeTheme(theme: string) {
    this.currentTheme = theme;
    this.themeService.setTheme(theme);
    this.themeSubscribeService.receiveTheme(theme);
  }

  /**
   * 页签
   */
  tabs = []
  selectedIndex = 0;
  loadTabs() {
    if (this.tabs.length !== 0) {
      return
    }
    if (this.breadcrumbs?.length > 0) {
      this.tabs = [{ name: this.breadcrumbs[this.breadcrumbs.length - 1], url: this.router.url }]
    }
  }
  closeTab({ index }: { index: number }): void {
    if (this.tabs.length <= 1) {
      return
    }
    this.tabs.splice(index, 1);
    if (this.selectedIndex === index) {
      this.selectedIndex = this.tabs.length - 1
      this.navigateByUrl(this.tabs[this.selectedIndex]?.url)
    }
  }

  changeTab({ name, url }: { name, url }) {
    // change 'item.name === name' to 'item.name.zh === name.zh'
    // to fix bug: alarm runtime tab duplicatedly open
    let index = this.tabs.findIndex(item => item.name.zh === name.zh)
    if (index !== -1) {
      this.selectedIndex = index
      return
    }
    this.tabs.push({ name, url })
    this.selectedIndex = this.tabs.length - 1
  }

  navigateByUrl(url: string) {
    if (url.includes('http')) {
      if (url.includes('?url=')) {
        let url2 = decodeURIComponent(url.split('?url=')[1])
        this.router.navigate(['/external-link/index'], { queryParams: { url: url2 } })
      } else {
        this.router.navigate(['/external-link/index'], { queryParams: { url } })
      }
    } else {
      this.router.navigateByUrl(url);
    }
  }

  menuName(name) {
    return name[this.translation.currentLang];
  }
}
